import React from 'react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { ChevronDown } from 'lucide-react'

interface TransactionStatusHeaderActionProps {
  statusName: string
  onStatusClick(): void
  menuContent?: React.ReactNode
  menuDisabled?: boolean
}

export const TransactionStatusHeaderAction: React.FC<TransactionStatusHeaderActionProps> = ({
  statusName,
  onStatusClick,
  menuContent,
  menuDisabled = false,
}) => {
  return (
    <div className='ml-auto flex items-center gap-2 text-base font-semibold'>
      <span>Status:</span>
      <Badge variant='status' onClick={onStatusClick}>
        {statusName}
      </Badge>
      {menuContent ? (
        <DropdownMenu>
          <DropdownMenuTrigger
            render={
              <Button
                type='button'
                variant='ghost'
                size='icon'
                aria-label='Change status'
                disabled={menuDisabled}
              />
            }
          >
            <ChevronDown />
          </DropdownMenuTrigger>
          <DropdownMenuContent align='end'>{menuContent}</DropdownMenuContent>
        </DropdownMenu>
      ) : null}
    </div>
  )
}
